import { render, staticRenderFns } from "./CmsList.vue?vue&type=template&id=2ba1f22e&scoped=true"
import script from "./CmsList.vue?vue&type=script&lang=js"
export * from "./CmsList.vue?vue&type=script&lang=js"
import style0 from "./CmsList.vue?vue&type=style&index=0&id=2ba1f22e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba1f22e",
  null
  
)

export default component.exports